// Same visual language as the corporate site's hero overlay: a quiet mesh of
// pulsing nodes with packets running the links. It replaces the photo backdrop
// the hero used to carry, which competed with the product card sitting on it.
const NODES = [
  { x: 60, y: 160 },
  { x: 190, y: 70 },
  { x: 250, y: 330 },
  { x: 420, y: 200 },
  { x: 480, y: 470 },
  { x: 610, y: 110 },
  { x: 700, y: 340 },
  { x: 820, y: 200 },
  { x: 880, y: 480 },
  { x: 940, y: 90 },
];

const LINKS = [
  [0, 1],
  [0, 2],
  [1, 3],
  [2, 3],
  [2, 4],
  [3, 5],
  [3, 6],
  [4, 6],
  [5, 7],
  [6, 7],
  [6, 8],
  [7, 9],
];

const PACKET_LINKS = [
  [0, 1],
  [3, 6],
  [6, 7],
  [2, 4],
];

// "slice" rather than "none" for preserveAspectRatio: the latter squashes the
// nodes into slivers on narrow viewports.
const NetworkOverlay = () => (
  <svg
    viewBox="0 0 1000 600"
    preserveAspectRatio="xMidYMid slice"
    className="hero-network"
    aria-hidden="true"
  >
    {LINKS.map(([a, b], i) => (
      <line
        key={i}
        x1={NODES[a].x}
        y1={NODES[a].y}
        x2={NODES[b].x}
        y2={NODES[b].y}
        strokeWidth="1"
      />
    ))}

    {PACKET_LINKS.map(([a, b], i) => (
      <circle
        key={`packet-${i}`}
        cx={NODES[a].x}
        cy={NODES[a].y}
        r="3"
        className="network-packet"
        style={{
          "--dx": `${NODES[b].x - NODES[a].x}px`,
          "--dy": `${NODES[b].y - NODES[a].y}px`,
          animationDuration: `${5 + i}s`,
          animationDelay: `${i * 0.9}s`,
        }}
      />
    ))}

    {NODES.map((node, i) => (
      <circle
        key={i}
        cx={node.x}
        cy={node.y}
        r="3.5"
        className="network-node"
        style={{ animationDelay: `${i * 0.25}s` }}
      />
    ))}
  </svg>
);

export default NetworkOverlay;
